import { applyMask, MaskMode } from '@intigral/utils';
import user from './user';
import type { IUserData } from '@intigral/domain/lib/entity/interface/iLoginEntities';
import type { Kochava } from 'kochava';

export function identifyUser(kochava: Kochava) {
    const userInfo: IUserData | null = user.getUserInfo();
    if (!userInfo) return;
    const kochavaUserId =
        userInfo.uid || userInfo.accountId?.toString() || applyMask(userInfo.username, MaskMode.Partial) || '';
    kochavaIdentity(kochava, 'userId', kochavaUserId);
}
export const kochavaIdentity = (kochava: Kochava, key: string, value: string) => {
    if (typeof kochava == 'undefined' || typeof kochava !== 'object' || !('registerIdentityLink' in kochava)) {
        return false;
    }
    kochava?.registerIdentityLink(key, value);
};
export const sendKochavaCustomEvent = (kochava: Kochava, eventName: string, properties: any) => {
    if (typeof kochava == 'undefined' || typeof kochava !== 'object' || !('sendEvent' in kochava)) {
        return false;
    }
    if (typeof properties !== 'undefined') {
        kochava?.sendEvent(eventName, properties);
    } else {
        kochava?.sendEvent(eventName);
    }
};
export const sendKochava = (kochava: Kochava, props: any) => {
    if (kochava) {
        sendKochavaCustomEvent(kochava, 'Viewership', {
            id: props?.Id || '',
            title: props?.text || '',
            programType: props?.programType || '',
            language: props?.language[0] || '',
            titleTag: props?.category || '',
        });
    }
};

export const sendLiveTvKochava = (kochava: Kochava, props: any, playerType: string) => {
    if (kochava) {
        sendKochavaCustomEvent(kochava, 'Viewership', {
            id: props?.channel?.channelID || '',
            title: props?.channel?.channelTitle || '',
            programType: playerType || '',
            language: props?.currLang || '',
            titleTag: props?.channel?.guid || '',
        });
    }
};
